import React, { Component } from 'react';
import SiteHeaderUtils from '../utils/SiteHeaderUtils';
import BrowserUtils from '../utils/BrowserUtils';
import HeaderLabelComponent from './HeaderLabelComponent';
import HeaderLinkComponent from './HeaderLinkComponent';
import InternetBankingActions from '../actions/InternetBankingActions';
import SiteHeaderActionCreator from '../actions/SiteHeaderActionCreator';
import { focusOnFirstComponent } from '../components/common/focusOnFirstComponent';
import StatementsPreferencesActionCreator from '../actions/StatementsPreferencesActionCreator';
import RenameAccountsActionCreator from '../actions/RenameAccountsActionCreator';
import AccountsActionCreator from '../actions/AccountsActionCreator';
import SiteHeaderStore from '../stores/SiteHeaderStore';
import AccountsStore from '../stores/AccountsStore';
import UserManagementStore from '../stores/UserManagementStore';
import AppStore from '../stores/AppStore';
import SessionActionCreator from '../../js/actions/SessionActionCreator';
import envConfig from '../../static/config';
import _ from 'lodash';
import cx from 'classnames';
import MessageStore from '../stores/MessageStore';
import SecurityDeviceStore from '../stores/SecurityDeviceStore';
import StringConstants from '../constants/StringConstants';
import NavigateToWebApps from '../utils/NavigateToWebApps';
import NavigationConfirmationModal from '../components/common/NavigationConfirmationModal';
import MasterCardAlertStore from '../stores/MasterCardAlertStore';
import MasterCardAlertActionCreator from '../../js/actions/MasterCardAlertActionCreator';
import FavouritesStore from '../stores/AccountsStore/FavouritesStore';
import { isCardManagementEnabled } from '../utils/CardManagementUtils';
import { isManagePersonalDetailsEnabled } from '../utils/ManagePersonalDetailsUtils';

const getExclusionList = (shouldActivateHardToken) =>
  shouldActivateHardToken ? [] : ['activateYourSecurityToken'];
const getHomePageMenuItem = (items) => items.find((i) => i.id === 'accounts');

let counter = 0;

const [CONSENT_MANAGE, CONSENT_MANAGE_VM, CONSENT_MANAGE_B] = [
  'consentManage',
  'consentManageVM',
  'consentManageB',
];

// What menu options to exclude for a particular brand value for OB Consent Management
const consentManageExclusionOptions = {
  CB: [CONSENT_MANAGE_B, CONSENT_MANAGE_VM],
  YB: [CONSENT_MANAGE_B, CONSENT_MANAGE_VM],
  DYB: [CONSENT_MANAGE, CONSENT_MANAGE_VM],
  VM: [CONSENT_MANAGE_B, CONSENT_MANAGE],
};

const showAccountOrder = () => {
  if (envConfig.isLcvEnabled && UserManagementStore.isSMEUser()) {
    return true;
  } else {
    return (
      !AccountsStore.isSingleAccount() && !UserManagementStore.isNominatedUser()
    ); // Display account order if user have multiple account
  }
};
class SiteHeader extends Component {
  constructor(props) {
    super(props);

    // DOM Element Refs
    this.headerElementRef = null;
    this.accessibilityFocusRef = null;

    this.setHeaderRef = this.setHeaderRef.bind(this);
    this.setAccessibilityFocusRef = this.setAccessibilityFocusRef.bind(this);
    this.getNavigationItems = this.getNavigationItems.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.moreClick = this.moreClick.bind(this);
    this.getMoreLink = this.getMoreLink.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.headerClick = this.headerClick.bind(this);
    this.onAccountsStoreChange = this.onAccountsStoreChange.bind(this);
    this.cancelClick = this.cancelClick.bind(this);
    this.onWebTaskChange = this.onWebTaskChange.bind(this);
    this.overlayclick = this.overlayclick.bind(this);
    this.keyDownPressed = this.keyDownPressed.bind(this);
    this.trackFocusIn = this.trackFocusIn.bind(this);
    this.onMessageStoreChange = this.onMessageStoreChange.bind(this);
    this.onSecurityDeviceStoreChange =
      this.onSecurityDeviceStoreChange.bind(this);
    this.leavePage = this.leavePage.bind(this);
    this.stayOnPage = this.stayOnPage.bind(this);
    this.logoClick = this.logoClick.bind(this);
    this.handleGoHomeRequest = this.handleGoHomeRequest.bind(this);
    this.checkMenuItemCondition = this.checkMenuItemCondition.bind(this);

    const shouldActivateHardToken = SecurityDeviceStore.hasOrderedToken();

    this.state = {
      items: SiteHeaderUtils.getMenuItems(envConfig.brandId),
      device: BrowserUtils.getView(),
      openCss: '',
      showList: false,
      currentMenu: SiteHeaderStore.getCurrentMenu(),
      disableFlag: SiteHeaderStore.getDisableFlag(),
      isSideBar: SiteHeaderStore.getSideBarFlag(),
      messageCount: MessageStore.getMessageCount(),
      displayLeavePopup: false,
      isActivationLinkPristine: true,
      shouldActivateHardToken,
      isLargeCustomer: FavouritesStore.isLargeCustomer(),
    };
  }

  componentDidMount() {
    SiteHeaderActionCreator.setCurrentMenu(this.state.items[0]);
    FavouritesStore.addChangeListener(this.onStoreChange);
    SiteHeaderStore.addChangeListener(this.onStoreChange);
    AccountsStore.addChangeListener(this.onAccountsStoreChange);
    MessageStore.addChangeListener(this.onMessageStoreChange);
    SecurityDeviceStore.addChangeListener(this.onSecurityDeviceStoreChange);
    AppStore.addChangeListener(this.onWebTaskChange);
    window.addEventListener('resize', this.onResize);
    if (envConfig.brandId !== 'VM') {
      window.addEventListener('scroll', this.onScroll);
    }
  }

  componentDidUpdate(prevProp, prevState) {
    // @todo - really not sure why we were forcing focus to go to the top of the page on a menu change?
    if (prevState.currentMenu.id !== this.state.currentMenu.id) {
      focusOnFirstComponent(this.accessibilityFocusRef);
    }

    if (this.props.triggerGoHome) {
      this.props.resetGoHome();
      this.handleGoHomeRequest();
    }
  }

  componentWillUnmount() {
    SiteHeaderStore.removeChangeListener(this.onStoreChange);
    AccountsStore.removeChangeListener(this.onAccountsStoreChange);
    AppStore.removeChangeListener(this.onWebTaskChange);
    MessageStore.removeChangeListener(this.onMessageStoreChange);
    FavouritesStore.removeChangeListener(this.onStoreChange);
    window.removeEventListener('resize', this.onResize);
    if (envConfig.brandId !== 'VM') {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  setHeaderRef(element) {
    this.headerElementRef = element;
  }

  setAccessibilityFocusRef(element) {
    this.accessibilityFocusRef = element;
  }

  onStoreChange() {
    if (FavouritesStore.getLoad()) {
      this.setState({ isLargeCustomer: FavouritesStore.isLargeCustomer() });
    }
    if (SiteHeaderStore.getCurrentMenu().id !== this.state.currentMenu.id) {
      this.setState({
        currentMenu: SiteHeaderStore.getCurrentMenu(),
      });
    }
    if (SiteHeaderStore.getSideBarFlag() !== this.state.isSideBar) {
      this.setState({
        isSideBar: SiteHeaderStore.getSideBarFlag(),
      });
    }
    if (!SiteHeaderStore.getModalFlag()) {
      this.setState({
        displayLeavePopup: false,
      });
    }
  }

  onResize() {
    if (BrowserUtils.getView() !== this.state.device) {
      this.setState({
        device: BrowserUtils.getView(),
      });
    }
  }

  onAccountsStoreChange() {
    this.forceUpdate();
  }

  onWebTaskChange() {
    const webTask = AppStore.getAll().webTaskId;
    let updateMenu = _.filter(this.state.items, (item) => {
      return item.navAction === webTask;
    });
    if (updateMenu.length === 0) {
      updateMenu = _.filter(
        SiteHeaderUtils.getSubHeadings('accountprefs'),
        (item) => {
          return (
            webTask !== StringConstants.WEB_RENAME_ACCOUNT &&
            item.navAction === webTask
          );
        }
      );
    }
    updateMenu.length > 0 &&
      SiteHeaderActionCreator.setCurrentMenu(updateMenu[0]);
    this.setState({
      displayLeavePopup: false,
    });
  }

  onScroll() {
    if (this.headerElementRef !== null) {
      const distanceY = window.pageYOffset;

      if (distanceY >= 66.67) {
        this.headerElementRef.classList.add('is-sticky');
      } else {
        this.headerElementRef.classList.remove('is-sticky');
      }
    }
  }

  onMessageStoreChange() {
    this.setState({
      messageCount: MessageStore.getMessageCount(),
    });
  }

  onSecurityDeviceStoreChange() {
    const shouldActivateHardToken = SecurityDeviceStore.hasOrderedToken();
    this.setState({
      shouldActivateHardToken,
    });
  }

  getNotificationIcon() {
    const hasSecureMessageNotification =
      envConfig.isSecureMessageEnabled &&
      !UserManagementStore.isBusinessUser() &&
      this.state.messageCount;
    const hasActivateTokenNotification =
      this.state.shouldActivateHardToken && this.state.isActivationLinkPristine;
    if (hasSecureMessageNotification || hasActivateTokenNotification) {
      return (
        <div>
          <span className="c-site-nav__badge badge badge--message">&nbsp;</span>
        </div>
      );
    }
    return null;
  }

  getMoreLink(items) {
    return (
      <li className={`c-site-nav__item ${this.state.openCss}`}>
        <button
          data-test-id="button-show-more-navigation"
          aria-controls="more-navigation"
          aria-expanded={this.state.showList}
          className="c-site-nav__link js-site-nav-parent"
          onClick={this.moreClick}
        >
          <span className="c-site-nav__badge-container">
            {this.getNotificationIcon()}
          </span>
          <span className="c-site-nav__title">
            {this.state.showList ? 'Close' : 'More'}
          </span>
        </button>
        {this.state.showList ? (
          <ul
            id="more-navigation"
            aria-expanded={this.state.showList}
            className="c-site-subnav c-site-subnav@small c-site-subnav@medium c-site-subnav@large c-site-subnav@xlarge"
          >
            {items}
          </ul>
        ) : (
          ''
        )}
      </li>
    );
  }

  getNavigationItems() {
    const { items, device } = this.state;
    const displayItems = [];
    const listItems = [];
    const length = SiteHeaderUtils.getLength(device);
    const exclusionList = getExclusionList(this.state.shouldActivateHardToken);
    exclusionList.push(...consentManageExclusionOptions[envConfig.brandId]);
    AccountsStore.isYouthAccount() && exclusionList.push('marketingPreference');

    let logoutItem = {};
    _.map(items, (item) => {
      if (AccountsStore.isYouthAccount() && item.title === 'Products') {
        return;
      }
      if (this.checkMenuItemCondition(item.id)) {
        if (item.priority === 'P1') {
          let highlightMenuFlag = false;
          this.state.currentMenu.id === item.id
            ? (highlightMenuFlag = true)
            : (highlightMenuFlag = false);
          displayItems.push(
            <HeaderLabelComponent
              key={`HeaderLabelComponent_displayItems_${
                displayItems.length + 1
              }`}
              menuItem={item}
              headerClick={this.headerClick}
              highlightMenuFlag={highlightMenuFlag}
            />
          );
        } else if (item.priority === 'P2') {
          if (displayItems.length < length) {
            let highlightMenuFlag = false;
            this.state.currentMenu.id === item.id
              ? (highlightMenuFlag = true)
              : (highlightMenuFlag = false);
            displayItems.push(
              <HeaderLabelComponent
                key={`HeaderLabelComponent_P2_displayItems_${
                  displayItems.length + 1
                }`}
                menuItem={item}
                headerClick={this.headerClick}
                highlightMenuFlag={highlightMenuFlag}
              />
            );
          } else {
            listItems.push(
              <HeaderLinkComponent
                key={`HeaderLinkComponent_${listItems.length + 1}`}
                linkItem={item}
                headerClick={this.headerClick}
                checkMenuItemCondition={this.checkMenuItemCondition}
                exclusionList={exclusionList}
              />
            );
          }
        } else if (item.priority === 'P3') {
          logoutItem = item.id === 'logout' ? item : {};
          (this.state.device !== 'desktop' || item.id !== 'logout') &&
            listItems.push(
              <HeaderLinkComponent
                key={`HeaderLinkComponent_${listItems.length + 1}`}
                linkItem={item}
                headerClick={this.headerClick}
                checkMenuItemCondition={this.checkMenuItemCondition}
                exclusionList={exclusionList}
                count={this.state.messageCount}
              />
            );
        }
      }
    });
    return (
      <ul className="c-site-nav c-site-nav@small c-site-nav@medium">
        {displayItems}
        {this.getMoreLink(listItems)}
        {device === 'desktop' && (
          <li className="c-site-nav__item">
            <button
              className="c-site-nav__link"
              name="Log out"
              onClick={this.headerClick.bind(null, logoutItem, false)}
            >
              <span className="c-site-nav__title">Log out</span>
            </button>
          </li>
        )}
      </ul>
    );
  }

  getParentId(element) {
    let currentEle = element;
    let isParent = '';
    if (currentEle) {
      while (currentEle && currentEle.id !== 'main-header') {
        if (currentEle.id === 'more-navigation') {
          isParent = 'more-navigation';
          break;
        } else {
          currentEle = currentEle.parentElement;
        }
      }
    }
    return isParent;
  }

  trackFocusIn(e) {
    if (e.target instanceof Window) {
      if (this.state.showList) {
        this.setState({ showList: false });
      }
    } else {
      const ele = document.activeElement;
      if (this.state.showList) {
        const menu = this.getParentId(ele);
        if (!(ele.id === 'more-parent-id' || menu === 'more-navigation')) {
          this.setState({ showList: false });
        }
      }
    }
  }

  keyDownPressed(e) {
    counter++;
    if (
      (this.state.device === 'mobile' && counter === 7) ||
      (this.state.device === 'tablet' && counter === 6) ||
      (this.state.device === 'desktop' && counter === 4)
    ) {
      this.setState({ showList: false });
      counter = 0;
    }
  }

  checkMenuItemCondition(id) {
    switch (id) {
      case 'spending':
        return AccountsStore.getSpendingsFlag();
      case 'movemoney':
        return (
          AccountsStore.getPaymentsFlag() && !UserManagementStore.isSMEUser()
        );
      case 'movemoney-bib':
        return (
          AccountsStore.getPaymentsFlag() && UserManagementStore.isSMEUser()
        );
      case 'alerts':
        return (
          ((AccountsStore.getSweepsFlag() &&
            AccountsStore.getSweepsOutFlag()) ||
            AccountsStore.getAlertsFlag()) &&
          !this.state.isLargeCustomer
        );
      case 'stmtprefs':
        return (
          AccountsStore.getStmtPreferenceFlag() &&
          !envConfig.isPaperFreePreferencesEnabled
        );
      case 'paperfree':
        return (
          AccountsStore.getStmtPreferenceFlag() &&
          envConfig.isPaperFreePreferencesEnabled
        );
      case 'accountorder':
        return showAccountOrder();
      case 'accountprefs':
        return !(
          AccountsStore.isCreditCardUser() ||
          UserManagementStore.isNominatedUser()
        );
      case 'contactPreferences':
        return (
          !UserManagementStore.isNominatedUser() &&
          envConfig.isContactDetailsEnabled &&
          !UserManagementStore.isSMEUser()
        );
      case 'mymessage':
        return (
          envConfig.isSecureMessageEnabled &&
          !UserManagementStore.isAdditionalUser() &&
          !UserManagementStore.isNominatedUser() &&
          (!UserManagementStore.isBusinessUser() ||
            envConfig.isDocumentLibraryEnabled)
        );
      case 'my-documents':
        return (
          envConfig.isDocumentLibraryEnabled &&
          !UserManagementStore.isAdditionalUser() &&
          !UserManagementStore.isNominatedUser()
        );
      case 'marketingPreference':
        return !UserManagementStore.isAdditionalUser();
      case 'balanceexport':
        return !UserManagementStore.isAdditionalUser();
      case 'renameaccount':
        return envConfig.isNicknameAmendEnabled && !this.state.isLargeCustomer;
      case 'companylimits':
        return (
          envConfig.isUserManagementEnabled &&
          UserManagementStore.isUserReadEnabled() &&
          UserManagementStore.isCorporateAdmin()
        );
      case 'usermanagement':
        return (
          envConfig.isUserManagementEnabled &&
          UserManagementStore.isUserReadEnabled()
        );
      case 'manageMobileDevice':
        return (
          envConfig.isDeviceManagementEnabled &&
          UserManagementStore.isManageDeviceEnabled() &&
          !UserManagementStore.isNominatedUser()
        );
      case 'manageCard':
        return isCardManagementEnabled();
      case 'manageDebitCards':
        return AccountsStore.isManageDebitCardEnabled();
      case 'manageaccountpools':
        return (
          UserManagementStore.isSMEUser() &&
          envConfig.isManageAccountPoolsEnabled &&
          AccountsStore.getTotalNumberOfAccounts() > 1
        );
      case 'overdraftCostCalculator':
        return (
          AccountsStore.hasAccountWithViewBalanceCapabilityAsFalse() ||
          (this.state.isLargeCustomer &&
            FavouritesStore.hasAccountWithViewBalanceCapabilityAsFalse())
        );
      case 'personalContactDetails':
        return isManagePersonalDetailsEnabled();
      case 'marketplace':
        return envConfig.isMarketplaceEnabled && UserManagementStore.isCA();
      case 'lastLogin':
        return !UserManagementStore.isBusinessUser();
      default:
        return true;
    }
  }

  moreClick() {
    !this.state.showList
      ? this.setState({
          openCss: 'is-open js-site-nav-parent--is-open',
          showList: true,
        })
      : this.setState({ openCss: '', showList: false });
  }

  handleGoHomeRequest() {
    const homeItem = getHomePageMenuItem(this.state.items);
    this.headerClick(homeItem, false);
  }

  headerClick(item, highlightMenuFlag) {
    if (!this.state.displayLeavePopup && SiteHeaderStore.getModalFlag()) {
      this.setState({ showList: false, displayLeavePopup: true });
      SiteHeaderActionCreator.toBeSelectedNavItem(item);
      return;
    }
    if (!SiteHeaderStore.getDisableFlag()) {
      if (
        item.id !== 'managecredentials' ||
        item.id !== 'contactPreferences' ||
        item.id !== 'marketingPreference' ||
        item.id !== 'useraccess' ||
        item.id !== 'manageMobileDevice'
      ) {
        highlightMenuFlag
          ? SiteHeaderActionCreator.setCurrentMenu(item)
          : SiteHeaderActionCreator.setCurrentMenu({});
      }
      this.state.showList && this.setState({ openCss: '', showList: false });
      SiteHeaderUtils.menuClicked();
      switch (item.id) {
        case 'accounts':
          InternetBankingActions.navigateToWebTask(item.navAction);
          break;
        case CONSENT_MANAGE:
        case CONSENT_MANAGE_B:
        case CONSENT_MANAGE_VM:
          NavigateToWebApps.navigateTo(envConfig.consentManageUrl);
          break;
        case 'marketingPreference':
          NavigateToWebApps.navigateTo(envConfig.marketingPreferenceLink);
          break;
        case 'balanceexport':
          AccountsActionCreator.requestBalance();
          break;
        case 'managecredentials':
          NavigateToWebApps.navigateTo(envConfig.manageCredentialLink);
          break;
        case 'manageMobileDevice':
          NavigateToWebApps.navigateTo(envConfig.deviceManagementLink);
          break;
        case 'companylimits':
          NavigateToWebApps.navigateTo(
            `${envConfig.userManagementLink}&showTransactionLimit=true`
          );
          break;
        case 'useraccess':
          NavigateToWebApps.navigateTo(envConfig.userManagementLink);
          break;
        case 'accountorder':
          StatementsPreferencesActionCreator.setBackPageReference(
            StringConstants.WEB_HOMEPAGE
          );
          InternetBankingActions.navigateToWebTask(item.navAction);
          break;
        case 'renameaccount':
          RenameAccountsActionCreator.setBackPageReference(
            StringConstants.WEB_HOMEPAGE
          );
          InternetBankingActions.navigateToWebTask(item.navAction);
          break;
        case 'stmtprefs':
          StatementsPreferencesActionCreator.setBackPageReference(
            StringConstants.WEB_HOMEPAGE
          );
          InternetBankingActions.navigateToWebTask(item.navAction);
          break;
        case 'logout':
          this.logout();
          break;
        case 'activateYourSecurityToken':
          this.setState({
            isActivationLinkPristine: false,
          });
          InternetBankingActions.navigateToWebTask(item.navAction);
          break;
        case 'alerts':
          const singleAlertAccountID =
            AccountsStore.getAlertsAvailableSingleAccount();
          singleAlertAccountID
            ? MasterCardAlertActionCreator.setManageAlertsAccountID(
                singleAlertAccountID
              )
            : MasterCardAlertActionCreator.setManageAlertsAccountID();
          MasterCardAlertStore.setNavigation(StringConstants.WEB_HOMEPAGE);
          InternetBankingActions.navigateToWebTask(
            StringConstants.WEB_MASTERCARD_ALERTS
          );
          break;
        case 'overdraftCostCalculator':
          const targetBlank = true;
          NavigateToWebApps.navigateToBrochurewarePage(
            envConfig.overdraftCostCalculatorURL,
            targetBlank
          );
          break;
        case 'marketplace':
          NavigateToWebApps.navigateTo(envConfig.marketplaceLink);
          break;
        case 'closeAccount':
          NavigateToWebApps.navigateToBrochurewarePage(
            envConfig.accountClosureLink,
            true
          );
          break;
        default:
          InternetBankingActions.navigateToWebTask(item.navAction);
          break;
      }
    }
  }

  cancelClick() {
    SiteHeaderActionCreator.setManageCredFlag(false);
  }

  logout() {
    SessionActionCreator.requestAccessTokenReset(true);
  }

  skipToMainContent() {
    const webTask = AppStore.getAll().webTaskId;
    const items = SiteHeaderUtils.getNonAccessibleModules();
    return !_.includes(items, webTask);
  }

  logoClick() {
    if (!this.state.displayLeavePopup && SiteHeaderStore.getModalFlag()) {
      this.setState({ showList: false, displayLeavePopup: true });
      SiteHeaderActionCreator.toBeSelectedNavItem(
        _.find(this.state.items, { id: 'accounts' })
      );
      return;
    }
    InternetBankingActions.navigateToWebTask(StringConstants.WEB_HOMEPAGE);
  }

  overlayclick() {
    this.setState({
      showList: false,
      openCss: '',
    });
  }

  leavePage() {
    if (this.props.onLeavePage) {
      this.props.onLeavePage();
    }
    const modalConfigClear = {
      displayLeavePopup: false,
    };
    SiteHeaderActionCreator.setModalConfig(modalConfigClear);
    this.setState({
      displayLeavePopup: false,
    });
    const toBeSelectedMenu = SiteHeaderStore.getToBeSelectedMenu();
    this.headerClick(toBeSelectedMenu, false);
  }

  stayOnPage() {
    SiteHeaderStore.setToBeSelectedMenu();
    this.setState({
      displayLeavePopup: false,
    });
  }

  /**
   * Resorting to JS to ensure a consistent experience
   * https://bugzilla.mozilla.org/show_bug.cgi?id=308064
   *
   * The site-main element is scattered across pages & is non focusable as
   * previous developers have added tabIndex="-1".
   * So going to dynamically set the tabIndex so we can put focus onto it
   */
  handleSkipLink = (e) => {
    const siteMainElem = document.getElementById('site-main');
    siteMainElem.setAttribute('tabIndex', 0);
    siteMainElem.focus();
    siteMainElem.setAttribute('tabIndex', -1);
    e.preventDefault();
  };

  render() {
    const overlayClassName = cx({
      'c-overlay overlay__custom--zindex': true,
      overlay__show: this.state.showList,
    });
    return (
      <header
        id="main-header"
        ref={this.setHeaderRef}
        className="c-site-header c-site-header@small c-site-header@medium js-site-header"
      >
        <span
          id="accessibility"
          className="u-visually-hidden off-screen"
          ref={this.setAccessibilityFocusRef}
          aria-hidden="true"
        >
          .
        </span>
        <a
          href="#site-main"
          onClick={this.handleSkipLink}
          className="c-skiplink"
        >
          Skip to main content
        </a>
        <div className="c-site-header__inner">
          <div className="c-site-header__logo">
            <div className="c-site-title c-site-title@small c-site-title@medium c-site-title@large">
              <h1 className="c-site-title__logo">
                <a
                  href="javascript:void(0);"
                  className="c-site-title__link"
                  name="Accounts"
                  onClick={this.logoClick}
                >
                  Accounts
                </a>
              </h1>
              <p className="c-site-title__subtitle">
                {'Powered by Clydesdale '}
                <br className="u-hidden@xsmall u-hidden@small" />
                {'Bank & Yorkshire Bank'}
              </p>
            </div>
          </div>
          <nav
            onFocus={this.trackFocusIn}
            id="site-nav"
            className="c-site-header__nav"
            role="navigation"
          >
            {this.state.showList && (
              <div
                ref="overlay"
                className={overlayClassName}
                onClick={this.overlayclick}
              />
            )}
            {this.getNavigationItems()}
          </nav>
        </div>
        {this.state.displayLeavePopup && (
          <NavigationConfirmationModal
            leavePage={this.leavePage}
            stayOnPage={this.stayOnPage}
            modalConfig={SiteHeaderStore.getModalConfig()}
          />
        )}
      </header>
    );
  }
}

export default SiteHeader;
